import Canvas from "./index.js"
import Poin from "poin"
import App from "@frog/source/models/App.js"

// COPIED FROM SELECTION
function calculateRelativePosition({x, y}, dom) {
    if(dom == undefined) return {"x": 0, "y": 0}
    const bounds = dom.getBoundingClientRect()
    x = ((x - bounds.left) / bounds.width) * Canvas.size.width
    y = ((y - bounds.top) / bounds.height) * Canvas.size.height
    return {x, y}
}

const events = []
const relativePointer = {}

export function start() {
    window.addEventListener("mousedown", function(event) {
        const position = calculateRelativePosition({"x": event.clientX, "y": event.clientY}, Canvas.dom)
        events.push({"type": "cursordown", "position": position})
    })
    // window.addEventListener("mousemove", function(event) {
    //     const position = calculateRelativePosition({"x": event.clientX, "y": event.clientY}, Canvas.dom)
    //     pointer.previousPosition = pointer.currentPosition
    //     pointer.currentPosition = position
    //     events.push({"type": "cursormove", "position": position})
    // })

    // Canvas.dom.addEventListener("contextmenu", (event) => {
    //     event.preventDefault()
    // })
}

export function handleEvents(renderable) {
    while(events.length > 0) {
        const event = events.shift()

        const foundRenderable = findRenderableWithEvent(renderable, event)
        if(foundRenderable != undefined) {
            foundRenderable[event.type](event)
        }
    }

    // relativePointer.position = calculateRelativePosition(Poin.position, Canvas.dom)
    // hoverRenderable(renderable)
}

function findRenderableWithEvent(renderable, event) {
    if(renderable.events != undefined
    && renderable.events[event.type] != undefined
    && renderable.events[event.type] instanceof Function
    && isBounded(renderable.bounds, event.position)) {
        return renderable.events[event.type](event)
    }
    if(renderable.children != undefined) {
        return Object.values(renderable.children).find((child) => {
            return findRenderableWithEvent(child, event)
        })
    }
}

function hoverRenderable(renderable) {
    renderable.status = renderable.status || {}
    if(isBounded(renderable.bounds, relativePointer.position)) {
        renderable.status["hovered"] = true

        // if(Poin.isPressed()) {
        //     renderable.status["pressed"] = true
        // }
    }
    // if(renderable.events != undefined
    // && renderable.events["cursorout"] != undefined
    // && renderable.events["cursorout"] instanceof Function
    // && isBounded(renderable.bounds, pointer.previousPosition) == true
    // && isBounded(renderable.bounds, pointer.currentPosition) == false) {
    //     renderable.events["cursorout"](event)
    // }
    // if(renderable.events != undefined
    // && renderable.events["cursorover"] != undefined
    // && renderable.events["cursorover"] instanceof Function
    // && isBounded(renderable.bounds, pointer.previousPosition) == false
    // && isBounded(renderable.bounds, pointer.currentPosition) == true) {
    //     renderable.events["cursorover"](event)
    // }
    if(renderable.children != undefined) {
        Object.values(renderable.children).forEach((child) => {
            hoverRenderable(child)
        })
    }
}

function isBounded(bounds, position) {
    return bounds != undefined
        && position != undefined
        && bounds.x1 <= position.x
        && bounds.x2 >= position.x
        && bounds.y1 <= position.y
        && bounds.y2 >= position.y
}
